import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle<{ theme: any }>`
    :root {
        --primary: ${props => props.theme.primary || '#f58220'};
        --secondary: ${props => props.theme.secondary || '#d32f2f'};
        --background: ${props => props.theme.background || '#fffaf5'};
        --text: #333;
    }

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Inter', sans-serif;
        -webkit-tap-highlight-color: transparent;
    }

    body {
        background-color: var(--background);
        color: var(--text);
        overflow-x: hidden;
        padding-bottom: 100px;

        @media (min-width: 1024px) {
            padding-bottom: 0;
        }
    }

    button {
        cursor: pointer;
        border: none;
        outline: none;
    }

    input {
        outline: none;
    }

    /* Utilitários para scroll */
    .no-scrollbar::-webkit-scrollbar {
        display: none;
    }
    .no-scrollbar {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
`;
